export default __webpack_public_path__ + "static/media/ChevronDown.1c2660e6.svg";